module.exports = __webpack_public_path__ + "e5c34bd66d39d78c289580c1e3c81176.svg";